import { buildMenuTree, collectButtonPermissions, flattenMenuRoutes } from '@/utils/menu'
import { createRootLayoutRoute } from '@/router/routeMap'
import { getCachedMenu, setCachedMenu } from '@/utils/auth'

const state = {
  rawTree: getCachedMenu(),
  menuTree: buildMenuTree(getCachedMenu()),
  buttonPermissions: [],
  routes: [],
  routesGenerated: false
}

const mutations = {
  SET_PERMISSION_TREE (state, tree) {
    state.rawTree = tree || []
    state.menuTree = buildMenuTree(state.rawTree)
    state.buttonPermissions = collectButtonPermissions(state.rawTree)
    setCachedMenu(state.rawTree)
  },
  SET_ROUTES (state, routes) {
    state.routes = routes || []
    state.routesGenerated = true
  },
  RESET_PERMISSION (state) {
    state.rawTree = []
    state.menuTree = []
    state.buttonPermissions = []
    state.routes = []
    state.routesGenerated = false
  }
}

const actions = {
  generateRoutes ({ commit }, tree) {
    const sourceTree = tree || []
    const menuTree = buildMenuTree(sourceTree)
    const childRoutes = flattenMenuRoutes(menuTree)
    const layoutRoute = createRootLayoutRoute(childRoutes)
    commit('SET_PERMISSION_TREE', sourceTree)
    commit('SET_ROUTES', [layoutRoute])
    return [layoutRoute]
  },
  resetPermission ({ commit }) {
    commit('RESET_PERMISSION')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
